module.exports = __webpack_public_path__ + "img/esmeralda-pool-2.3368d77f.jpg";